<template>
  <base-modal>
    <h3 class="prompt">{{ willingToCallPrompt }}</h3>
    <radio-button
      :button-data="buttonData"
      name="willing-to-call"
      @click="submit($event)"
    />
  </base-modal>
</template>

<script>
import { mapState } from "vuex";
import RadioButton from "WhoDoYouKnowComponents/inputs/RadioButton.vue";
import BaseModal from "WhoDoYouKnowComponents/modals/BaseModal.vue";

export default {
  name: "WillingToCall",
  components: {
    RadioButton,
    BaseModal
  },
  inject: {
    eventsBus: { from: "eventsBus" }
  },
  data() {
    return {
      buttonData: [
        {
          id: "radio-button-yes",
          value: true,
          name: "Yes",
          label: "Yes"
        },
        {
          id: "radio-button-no",
          value: false,
          name: "No",
          label: "No"
        }
      ]
    };
  },
  computed: {
    ...mapState("campaign", {
      willingToCallPrompt: state => state.contentWillingToCall
    })
  },
  methods: {
    submit($event) {
      if ($event.target && $event.target.value) {
        this.eventsBus.$emit("clickWillingToCall", $event);
        this.eventsBus.$emit("showRelationshipForm", false);
      }
    }
  }
};
</script>
